/// <amd-module name="Widgets/NewWorkItemWidget/NewWorkItemWidgetDataProvider" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

interface IWorkItemTypesData {
    workItemTypes?: string[];
    hasNewWorkItemPermission: boolean;
}

export function getWorkItemTypes(pageContext: IVssPageContext): string[] {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    const newWorkItemData = contributionService.getData<IWorkItemTypesData>("ms.vss-work-web.new-workitem-data-provider");
    return newWorkItemData != null && newWorkItemData.workItemTypes && newWorkItemData.hasNewWorkItemPermission ? newWorkItemData.workItemTypes : [];
}
